// Fase 17.3, Plano 11 (D-10) — cliente HTTP da tela "Tintas e rendimento".
import type { ListaTintasDto, RendimentoPadraoTipoDto, TintaPadraoDefinidaDto, TipoTintaRendimento, UnidadeTinta } from '@pieltec/contracts';
import { apiFetch, apiMutate } from '../csrf-fetch';
import { lerErroApi } from '../vendas/erro-api';
import { ErroRoteiroApi } from './roteiros-api';

const BASE = '/api/v1/roteiros/tintas';

export interface FiltrosTintasWeb {
  readonly busca?: string;
  readonly somenteSemRendimento?: boolean;
}

export function listarTintas(filtros: FiltrosTintasWeb = {}): Promise<ListaTintasDto> {
  const params = new URLSearchParams();
  if (filtros.busca?.trim()) params.set('busca', filtros.busca.trim());
  if (filtros.somenteSemRendimento) params.set('semRendimento', 'true');
  const consulta = params.toString();
  return apiFetch<ListaTintasDto>(`${BASE}${consulta ? `?${consulta}` : ''}`);
}

/** Grava (ou limpa, com null) o rendimento em m²/kg ou m²/L; devolve o valor salvo pela API. */
export async function atualizarRendimentoDaTinta(materialId: string, rendimentoM2PorKg: string | null): Promise<string | null> {
  const resposta = await apiMutate(`${BASE}/${encodeURIComponent(materialId)}/rendimento`, { method: 'PATCH', body: { rendimentoM2PorKg } });
  if (!resposta.ok) {
    if (resposta.status === 403) throw new ErroRoteiroApi('Você não tem permissão para alterar o rendimento das tintas.', 403);
    const erro = await lerErroApi(resposta, 'Não foi possível salvar o rendimento. Tente novamente.');
    throw new ErroRoteiroApi(erro.mensagem, resposta.status);
  }
  return ((await resposta.json()) as { rendimentoM2PorKg: string | null }).rendimentoM2PorKg;
}

export async function definirRendimentoPadraoDoTipo(tipoTinta: TipoTintaRendimento, rendimentoM2PorUnidade: string | null, unidade: UnidadeTinta | null): Promise<RendimentoPadraoTipoDto> {
  const resposta = await apiMutate(`${BASE}/tipos/${encodeURIComponent(tipoTinta)}/rendimento-padrao`, {
    method: 'PATCH', body: { rendimentoM2PorUnidade, ...(rendimentoM2PorUnidade === null ? {} : { unidade }) },
  });
  if (!resposta.ok) {
    if (resposta.status === 403) throw new ErroRoteiroApi('Você não tem permissão para alterar o rendimento padrão.', 403);
    const erro = await lerErroApi(resposta, 'Não foi possível salvar o rendimento padrão. Tente novamente.');
    throw new ErroRoteiroApi(erro.mensagem, resposta.status);
  }
  return (await resposta.json()) as RendimentoPadraoTipoDto;
}

/** Quick 261017-gwz: marca (ou desmarca) a tinta padrão da cor; marcar troca a anterior do grupo no servidor. */
export async function definirTintaPadrao(materialId: string, padrao: boolean): Promise<TintaPadraoDefinidaDto> {
  const resposta = await apiMutate(`${BASE}/${encodeURIComponent(materialId)}/padrao`, { method: 'PATCH', body: { padrao } });
  if (!resposta.ok) {
    if (resposta.status === 403) throw new ErroRoteiroApi('Você não tem permissão para definir a tinta padrão.', 403);
    const erro = await lerErroApi(resposta, 'Não foi possível definir a tinta padrão. Tente novamente.');
    throw new ErroRoteiroApi(erro.mensagem, resposta.status);
  }
  return (await resposta.json()) as TintaPadraoDefinidaDto;
}
